import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component } from '@angular/core';
import { Type } from 'class-transformer';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { TranslateHelper } from '../../../../helpers/injector.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { DataCheck, WorkflowDialogContent } from '../../../workflow.dialog';

@Component({
    selector: 'wf-text-recognition-settings-item',
    templateUrl: 'text.recognition.settings.html'
})
export class TextRecognitionSettings extends WorkflowDialogContent {
    Data = new TextRecognitionSettingsData();

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'textRecognitionWFModule';
        reg.Caption = '@@Text Recognition';
        reg.GroupID = 'documentoperations';
        reg.Index = 60;
        reg.SettingsControl = TextRecognitionSettings;
        reg.SettingsTypeHelper = new TextRecognitionSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, TextRecognitionSettingsData);
        }
        if (!this.Data.Files || this.Data.Files.length == 0) {
            this.addFile();
        }
    }

    checkData(): DataCheck {
        const retVal = new DataCheck();
        const errors = [];
        if (!this.Data.Files || this.Data.Files.length == 0) {
            const text = '@@Bitte wahlen Sie eine oder mehrere Dateien';
            errors.push(TranslateHelper.TranslatorInstance.instant(text));
        } else if (this.Data.Files.some(x => !x.UseForState && !x.StatusKey)) {
            const text = '@@Bitte waehlen Sie fuer jede Datei einen Status Key oder den aktuellen Parameter';
            errors.push(TranslateHelper.TranslatorInstance.instant(text));
        }
        if (!this.Data.Target || (!this.Data.Target.UseForState && !this.Data.Target.StatusKey)) {
            const text = '@@Bitte vergeben Sie einen Status Key fuer das Ergebnis oder setzen Sie das Ergebnis als aktuellen Parameter';
            errors.push(TranslateHelper.TranslatorInstance.instant(text));
        }
        if (errors.length > 0) {
            retVal.IsCorrect = false;
            retVal.Error = errors.join('\n');
        }
        return retVal;
    }

    getResult() {
        this.Data.Files = this.Data.Files.filter(x => x.StatusKey || x.UseForState);
        return this.Data;
    }

    addFile() {
        if (this.Data) {
            if (this.Data.Files) {
                this.Data.Files.push(new FileSetting());
            } else {
                this.Data.Files = [new FileSetting()];
            }
        }
    }

    onDrop(ev) {
        if (ev && ev.currentIndex !== ev.previousIndex && this.Data && this.Data.Files) {
            moveItemInArray(this.Data.Files, ev.previousIndex, ev.currentIndex);
        }
    }

    useForStateChecked(ev, col) {
        if (ev && ev.checked && this.Data && this.Data.Files) {
            this.Data.Files.forEach(x => {
                x.UseForState = false;
            });
            col.UseForState = true;
        }
    }

    removeFile(index) {
        if (this.Data && this.Data.Files && this.Data.Files.length > 1 && this.Data.Files.length > index) {
            this.Data.Files.splice(index, 1);
        }
    }
}

// @dynamic
export class TextRecognitionSettingsData {
    InputType: number = 0;
    @Type(() => FileSetting)
    Files: FileSetting[] = [];
    Language: number = 0;
    OutputType: number = 0;
    Target: FileSetting = new FileSetting();
}

export class FileSetting {
    StatusKey: string;
    UseForState = false;
}

export class TextRecognitionSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new TextRecognitionSettingsData();
    }
    async fillActualState(module, state, wfData) {
        if (state) {
            const settings = WorkflowModuleSettingsHelper.GetSettingsFromModule(module);
            if (settings && settings.Target && settings.Target.StatusKey) {
                WorkflowModuleSettingsHelper.AddStatusKeysToState(state, [settings.Target.StatusKey]);
            }
        }
    }
}
